module.exports = __webpack_public_path__ + "static/img/clothing_09.b3288a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_09.png
// module id = AByu
// module chunks = 0